import {
  DeleteOutlined,
  EditOutlined,
  ExclamationCircleOutlined,
  PlusOutlined,
  ReloadOutlined
} from "@ant-design/icons";
import {
  Button,
  Card,
  Col,
  Form,
  Input,
  Modal,
  Row,
  Select,
  Table,
  TreeSelect,
  message
} from "antd";
import { removeVietnameseTones } from "lib/admin";
import { get, includes, map, toLower } from "lodash";
import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import services from "services";
import CarManageModal from "../../components/car-manage/CarManageModal";

let searchTimer = null;
const SHOW_PARENT = TreeSelect.SHOW_PARENT;
const { TreeNode } = TreeSelect;
function BarrierCarPage() {
  const stationTreeData = useSelector(x => x.app.listStationsV2);

  const CARD_STYLE = {
    borderRadius: "0.42rem",
    boxShadow: "0px 0px 30px 0px rgba(82, 63, 105, 0.05)"
  };
  const [form] = Form.useForm();
  const [isFetching, setIsFetching] = useState(false);
  const [tableConfig, setTableConfig] = useState({
    pagination: {
      current: 1,
      pageSize: 20,
      showSizeChanger: true
    }
  });
  const [tableData, setTableData] = useState({
    dataSource: [],
    total: 0
  });
  const [modalConfig, setModalConfig] = useState({
    dataSource: null,
    isCreate: false,
    visible: false
  });
  const [listCar, setListCar] = useState([]);

  let rowKey = record => `${record.id}`;

  let getIndex = index =>
    (tableConfig.pagination.current - 1) * tableConfig.pagination.pageSize +
    index +
    1;

  let columns = [
    {
      title: "STT",
      dataIndex: "index",
      key: "stt",
      align: "center",
      render: (_, __, index) => getIndex(index)
    },
    {
      title: "Kho",
      dataIndex: "station_name",
      align: "center"
    },
    {
      title: "Username",
      dataIndex: "username",
      align: "center"
    },
    {
      title: "Tên đẩy đủ",
      dataIndex: "full_name",
      align: "center"
    },
    {
      title: "Biển số",
      dataIndex: "license_plate",
      align: "center"
    },
    {
      title: "Bộ phận",
      dataIndex: "department",
      align: "center"
    },
    {
      title: "Hành động",
      dataIndex: "action",
      align: "center",
      render: (_, item) => {
        const openModal = () => {
          setModalConfig(prev => {
            let next = { ...prev };
            next.visible = true;
            next.isCreate = false;
            next.dataSource = item;
            return next;
          });
        };

        const showDeleteConfirm = () => {
          Modal.confirm({
            title: "Xác nhận",
            icon: <ExclamationCircleOutlined />,
            okText: "Xác nhận",
            okType: "danger",
            cancelText: "Hủy",
            content: (
              <span>
                Xóa thông tin xe:
                <b className="text-danger ml-1">{item.license_plate}</b>
              </span>
            ),
            onOk() {
              services.IOT.deleteBarrierCar(item.license_plate).then(res => {
                if (res?.data?.success) {
                  message.success("Xóa thông tin thành công.");
                  onRefresh();
                } else {
                  message.error(
                    get(res, "data.message", "Xóa thông tin không thành công.")
                  );
                }
              });
            },
            onCancel() {}
          });
        };
        return (
          <div className="d-flex align-items-center justify-content-center">
            <EditOutlined
              title="Sửa thông tin nhóm"
              onClick={openModal}
              className="text-primary mr-2"
            />

            <DeleteOutlined
              onClick={showDeleteConfirm}
              className="text-danger"
            />
          </div>
        );
      }
    }
  ];

  const _handleToggleModal = config => {
    setModalConfig(prev => ({
      ...prev,
      visible: config.visible,
      dataSource: config.dataSource,
      isCreate: config.isCreate
    }));
  };

  const onValuesChange = () => {
    clearTimeout(searchTimer);
    searchTimer = setTimeout(async () => {
      setTableConfig(prev => ({
        ...prev,
        pagination: { ...prev.pagination, current: 1 }
      }));
    }, 500);
  };

  const onChangeTable = pagination => {
    setTableConfig(prev => ({ ...prev, pagination }));
  };

  const getAllCar = async () => {
    let res = await services.IOT.getBarrierCarList({ page: 1, size: 99999 });
    const isSuccess = get(res, "success");
    let data = [];
    if (isSuccess) {
      data = get(res, "data", []);
    }
    setListCar(data);
  };

  const onRefresh = () => {
    setTableConfig(prev => ({
      ...prev,
      pagination: { ...prev.pagination }
    }));
    getAllCar();
  };

  const searchCar = useCallback(async params => {
    setIsFetching(true);
    let res = await services.IOT.getBarrierCarList(params);
    setIsFetching(false);
    const isSuccess = get(res, "success");
    let data = [];
    if (isSuccess) {
      data = get(res, "data", []);
    }
    let total = get(res, "total_elements", 0);
    setTableData(prev => {
      let next = { ...prev };
      next.dataSource = data;
      next.total = total;
      return next;
    });
  }, []);

  useEffect(() => {
    getAllCar();
  }, []);

  useEffect(
    () => {
      let params = {
        page: tableConfig.pagination.current,
        size: tableConfig.pagination.pageSize,
        username: form.getFieldValue("username")?.trim() || undefined,
        license_plate: form.getFieldValue("license_plate")?.trim() || undefined,
        station_ids: form.getFieldValue("station") || undefined
      };

      searchCar(params).then(r => r);
    },
    [form, tableConfig, searchCar]
  );

  return (
    <Row className="barrier-log__page" gutter={[8, 8]}>
      <Col span={24}>
        <Card
          bodyStyle={{ paddingBottom: "0" }}
          size="small"
          style={CARD_STYLE}
        >
          <Form form={form} layout={"vertical"} onValuesChange={onValuesChange}>
            <Row gutter={8} align="bottom">
              <Col md={5} xs={24}>
                <Form.Item name="station" label="Kho">
                  <TreeSelect
                    showSearch
                    allowClear
                    showCheckedStrategy={SHOW_PARENT}
                    style={{ width: "100%" }}
                    filterTreeNode={(input, treeNode) => {
                      return includes(
                        toLower(removeVietnameseTones(get(treeNode, "title"))),
                        toLower(removeVietnameseTones(input))
                      );
                    }}
                    dropdownStyle={{
                      maxHeight: 400,
                      overflow: "auto",
                      overflowX: "hidden"
                    }}
                    placeholder="Chọn kho"
                  >
                    {map(stationTreeData, station => {
                      return (
                        <TreeNode
                          value={station.region_name}
                          title={station.region_name}
                          key={station.region_name}
                          selectable={false}
                        >
                          {map(station.provinces, province => {
                            return (
                              <TreeNode
                                value={province.province_name}
                                title={province.province_name}
                                key={province.province_name}
                                selectable={false}
                              >
                                {map(province.stations, nestStation => {
                                  return (
                                    <TreeNode
                                      value={nestStation.station_id}
                                      title={nestStation.station_name}
                                      key={nestStation.station_id}
                                    />
                                  );
                                })}
                              </TreeNode>
                            );
                          })}
                        </TreeNode>
                      );
                    })}
                  </TreeSelect>
                </Form.Item>
              </Col>

              <Col md={3} xs={24}>
                <Form.Item label="Username" name="username">
                  <Input allowClear placeholder={"Nhập username"} />
                </Form.Item>
              </Col>

              <Col md={3} xs={24}>
                <Form.Item label="Biển số" name="license_plate">
                  <Select
                    placeholder="Nhập biển số xe"
                    showSearch
                    allowClear
                    options={(listCar || []).map(item => {
                      return {
                        label: item?.license_plate,
                        value: item?.license_plate
                      };
                    })}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Card>
      </Col>
      <Col span={24}>
        <Card size="small" style={CARD_STYLE}>
          <Row gutter={[8, 8]} justify="end">
            <Col>
              <div className="d-flex justify-content-end align-items-end">
                <Button
                  className="d-flex align-items-center mr-2"
                  onClick={() => onRefresh()}
                  icon={<ReloadOutlined />}
                >
                  Làm mới
                </Button>
                <Button
                  className="d-flex align-items-center"
                  type="primary"
                  onClick={() => {
                    setModalConfig(prev => ({
                      ...prev,
                      visible: true,
                      isCreate: true,
                      dataSource: null
                    }));
                  }}
                  icon={<PlusOutlined />}
                >
                  Thêm mới
                </Button>
              </div>
            </Col>
            <Col span={24}>
              <Table
                size="small"
                columns={columns}
                loading={isFetching}
                bordered
                dataSource={tableData.dataSource}
                rowKey={rowKey}
                pagination={{
                  ...tableConfig.pagination,
                  total: tableData.total
                }}
                onChange={onChangeTable}
                scroll={{
                  x: "max-content"
                }}
              />
            </Col>
          </Row>
        </Card>
      </Col>
      <CarManageModal
        config={modalConfig}
        _handleToggleModal={_handleToggleModal}
        _handleRefreshTable={onRefresh}
      />
    </Row>
  );
}

export default React.memo(BarrierCarPage);
